var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "yanchu_goods_list_inner" },
    [
      _vm.goodsList && _vm.goodsList.length > 0
        ? [
            _vm.value.config.extend_sort === 1
              ? _c(
                  "div",
                  { staticClass: "navbar" },
                  _vm._l(_vm.navbarList, function (nav, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        class: [
                          "nav-item",
                          index === _vm.activeNav && "current",
                        ],
                        on: {
                          click: function ($event) {
                            return _vm.changeNav(index)
                          },
                        },
                      },
                      [
                        _vm._v(" " + _vm._s(nav.label) + " "),
                        nav.icon
                          ? _c("i", { class: ["el-icon", nav.icon] })
                          : _vm._e(),
                      ]
                    )
                  }),
                  0
                )
              : _vm._e(),
            _vm.value.config.show_type === 2
              ? _c(
                  "div",
                  { staticClass: "box2" },
                  _vm._l(_vm.goodsList, function (item, index) {
                    return _c("div", { key: index, staticClass: "item" }, [
                      _c("div", {
                        staticClass: "pic",
                        style: {
                          backgroundImage: "url(" + item.goods_thumb + ")",
                        },
                      }),
                      _c("div", { staticClass: "right" }, [
                        _c("div", { staticClass: "info" }, [
                          _c("div", { staticClass: "name u-line-2" }, [
                            _vm._v(_vm._s(item.goods_name)),
                          ]),
                          _c("div", { staticClass: "inventory" }, [
                            _vm._v("库存: 900"),
                          ]),
                        ]),
                        _c("div", { staticClass: "price" }, [
                          _c("span", { staticClass: "num" }, [
                            _vm._v(
                              " " +
                                _vm._s(_vm._f("moneyFormat")(item.shop_price)) +
                                " "
                            ),
                          ]),
                          _vm._v(" 点 "),
                        ]),
                      ]),
                    ])
                  }),
                  0
                )
              : _c(
                  "div",
                  { staticClass: "box" },
                  _vm._l(_vm.goodsList, function (item, index) {
                    return _c("div", { key: index, staticClass: "item" }, [
                      _c("div", {
                        staticClass: "pic",
                        style: {
                          backgroundImage: "url(" + item.goods_thumb + ")",
                        },
                      }),
                      _c("div", { staticClass: "name u-line-2" }, [
                        _vm._v(_vm._s(item.goods_name)),
                      ]),
                      _c("div", { staticClass: "price" }, [
                        _c("span", { staticClass: "num" }, [
                          _vm._v(
                            " " +
                              _vm._s(_vm._f("moneyFormat")(item.shop_price)) +
                              " "
                          ),
                        ]),
                        _vm._v(" 点 "),
                      ]),
                    ])
                  }),
                  0
                ),
          ]
        : _c("empty", { attrs: { value: _vm.value } }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }